import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="w-24 h-24 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-6">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </div>
      <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">页面未找到</h1>
      <p className="text-foreground-500 mb-8 max-w-md">
        抱歉，您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页继续浏览。
      </p>
      <Link
        to="/"
        className="px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium text-sm transition-colors whitespace-nowrap"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        返回首页
      </Link>
    </div>
  );
}